package com.patronat.top.client.domain.reviews

import com.patronat.top.client.data.reviews.ClientReviewsRepository
import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.ReviewListResponse

data class GetClientVenueReviewsCommand(
    val venueId: String,
    val page: Int = 1,
    val pageSize: Int = 20
)

class GetClientVenueReviewsUseCase(
    private val repository: ClientReviewsRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<GetClientVenueReviewsCommand, DomainResult<ReviewListResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: GetClientVenueReviewsCommand): DomainResult<ReviewListResponse> {
        return repository.getVenueReviews(
            venueId = command.venueId,
            page = command.page,
            pageSize = command.pageSize
        )
    }
}
